export default "__VITE_PUBLIC_ASSET__76ef15cb__"